import { AiOutlineLeft } from "@react-icons/all-files/ai/AiOutlineLeft";
import cx from "classnames";
import { graphql, Link, PageProps } from "gatsby";
import React from "react";
import ExcerptDetails from "../components/ExcerptDetails";
import Metadata from "../components/Metadata";
import SEO from "../components/SEO";
import ShareWidget from "../components/ShareWidget";
import "../styles/post.css";
import * as css from "./BlogPost.module.css";

type Props = {
  data: Queries.BlogPostMarkdownQuery;
};

export default function BlogPost({ data }: Props) {
  const post = data.markdownRemark;

  if (!post) return null;

  const siteUrl = data.site?.siteMetadata?.siteUrl ?? "";
  const slug = post.fields?.slug ?? "";

  const backLink = (
    <div className={css.backLinkWrapper}>
      <Link className={css.backLink} to="/" data-cy="blog-home-back-link">
        <AiOutlineLeft /> Blog
      </Link>
    </div>
  );

  return (
    <article className={cx(css.blogPost, "blog-post")} data-cy="blog-post">
      {backLink}
      {post.frontmatter && (
        <header>
          <div className={css.topHeader}>
            <h1>{post.frontmatter.title}</h1>
            <Metadata {...post.frontmatter} />
          </div>
          <ExcerptDetails
            timeToRead={post.timeToRead}
            tags={post.frontmatter.tags}
          />
        </header>
      )}
      <div className={css.bottom}>
        {post.html && (
          <div
            className={css.postText}
            dangerouslySetInnerHTML={{ __html: post.html }}
            data-cy="blog-post-text"
          />
        )}
        <footer>
          <ShareWidget url={`${siteUrl}${slug}`} />
        </footer>
        {backLink}
      </div>
    </article>
  );
}

export const Head = ({ data, ...props }: PageProps & Props) => (
  <SEO
    {...props}
    data={{
      frontmatter: data.markdownRemark?.frontmatter ?? undefined,
      title: data.markdownRemark?.frontmatter?.title ?? "DoltHub Blog",
    }}
  />
);

export const query = graphql`
  fragment BlogPostFrontmatter on MarkdownRemarkFrontmatter {
    author
    authorHref
    date
    title
    tags
    description
    featuredImage {
      childImageSharp {
        gatsbyImageData(
          height: 627
          width: 1200
          placeholder: BLURRED
          transformOptions: { fit: CONTAIN }
          layout: FIXED
        )
      }
    }
  }
  query BlogPostMarkdown($slug: String!) {
    site {
      siteMetadata {
        siteUrl
      }
    }
    markdownRemark(fields: { slug: { eq: $slug } }) {
      html
      timeToRead
      frontmatter {
        ...BlogPostFrontmatter
      }
      fields {
        slug
      }
    }
  }
`;
